import React, { FC } from 'react';
import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { ResponsiveStylesProp } from 'client/widget-components/responsive-styles/responsiveStylesService';
import { Div } from 'client/widget-components/basicComponents';
import { SearchBtn } from './SearchBtn/SearchBtn';

interface Props {
    styles?: {
        iconBtn?: ResponsiveStylesProp;
    };
}

export const HiddenSearchComponentsForEditorComputedStyles: FC<Props> = ({
    styles,
}) => {
    return (
        <Div styles={hiddenDivStyles}>
            <SearchBtn styles={styles} dataAuto='' openSearchPopup={() => {}} />
        </Div>
    );
};

const hiddenDivStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'none',
    },
};
